import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import type { LoginFormData, AuthResponse, AuthError } from "../types/auth";
import loginAPI from "../api/login";
import { lsToken, storageName } from "../../../constans/auth";

function decodeJwt(token: string) {
  const payload = token.split(".")[1];
  if (!payload) return null;

  const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
  const json = atob(base64);

  return JSON.parse(json);
}

export const useLogin = (): UseMutationResult<
  AuthResponse,
  AuthError,
  LoginFormData
> => {
  return useMutation({
    mutationFn: loginAPI,
    onSuccess: ({ data }: any) => {
      const decodedToken = decodeJwt(data?.token);
      localStorage.setItem(storageName, JSON.stringify(decodedToken));
      localStorage.setItem(lsToken, data?.token);
    },
    onError: (error) => {
      console.error("Login error:", error);
    },
  });
};
